module.exports = __webpack_public_path__ + "img/close-icon.183c5377.svg";